/**
 * Issue #56 — category suggestion next to a category picker. Shown only
 * while the expense has no category; the user takes it with one click
 * (the normal category assignment, so it is a manual decision).
 */
import type { ExpenseCategorySuggestionDto } from '@armard/shared';
import { Button } from '../ui';

interface Props {
  suggestion: ExpenseCategorySuggestionDto;
  onAccept: (categoryId: string) => void;
  disabled?: boolean;
  testid?: string;
}

export function CategorySuggestion({ suggestion, onAccept, disabled, testid = 'category-suggestion' }: Props) {
  return (
    <div
      className="flex flex-wrap items-center gap-2 text-sm text-white/70"
      data-testid={testid}
    >
      <span className="text-white/50">Vorschlag:</span>
      <span className="text-white">{suggestion.name}</span>
      <span className="text-xs text-white/40">({suggestion.reason})</span>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        disabled={disabled}
        onClick={() => onAccept(suggestion.categoryId)}
        data-testid={`${testid}-accept`}
      >
        Übernehmen
      </Button>
    </div>
  );
}
